import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";

import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { UniqueVisitorsAddedToCartGraph } from "../../../../components/Graphs/graphs";
import { SelectWeeks,SelectUniqueBookingsStatus, SelectBookingsVisitors,SelectBookingsPercentVisitors,graphUniqueBookings} from "./uniqueBookingsSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";



const UniqueBookings = () => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];
  
  const UniqueBookingsData = useSelector(state => state.uniqueBookings)
  const loading = useSelector(SelectUniqueBookingsStatus);
  const weeks = useSelector(SelectWeeks)
  const visitors = useSelector(SelectBookingsVisitors)
  const percentOfVisitors = useSelector(SelectBookingsPercentVisitors)
  const graphLabel = UniqueBookingsData['data']?.[2]?.['label']


  useEffect(() => {
    if (!user) return null
    if(weeks.length===0) dispatch(graphUniqueBookings(user))
  }, [user, weeks])



  if (loading === 'loading') return <SingleGraphLoading/>
  
  return (
    <UniqueVisitorsAddedToCartGraph
      weeks={weeks}
      visitors={visitors}
      percentOfVisitors={percentOfVisitors}
      graphLabel={graphLabel}
   />
  )
}

export default UniqueBookings;